import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';
import { MAIN_THEME } from '@styles';

export const getHeaders = (
  layoutName: string
): Record<string, EnhancedTableHeader> => {
  const isPolicyLayout = layoutName === 'policy';
  const isGroupPolicyLayout = layoutName === 'groupPolicy';
  const isPolicyLikeLayout = isPolicyLayout || isGroupPolicyLayout;

  let policyUrlTemplate = '/production/policies/{id}';

  if (isGroupPolicyLayout) {
    policyUrlTemplate = '/production/group-policies/{id}';
  } else if (layoutName === 'productionDistribution') {
    policyUrlTemplate = '/reinsurance/prod-dist/{id}';
  }

  return {
    policyNumber: {
      name: 'policyNumber',
      title: isPolicyLikeLayout ? 'Policy Number' : 'Policy #',
      type: EnhancedTableHeaderType.Link,
      urlTemplate: policyUrlTemplate,
      openUrlInNewTab: false
    },
    'line.code': {
      name: 'line.code',
      title: 'Line',
      type: EnhancedTableHeaderType.Text
    },
    'subline.code': {
      name: 'subline.code',
      title: 'Subline',
      type: EnhancedTableHeaderType.Text
    },
    'plan.code': {
      name: 'plan.code',
      title: 'Plan',
      type: EnhancedTableHeaderType.Text
    },
    owner: {
      name: 'owner',
      title: 'Owner',
      type: EnhancedTableHeaderType.Text,
      hidden: !isPolicyLikeLayout,
      filterField: 'owner.person.fullName'
    },
    sublineCategory: {
      name: 'sublineCategory',
      title: 'Subline Category',
      type: EnhancedTableHeaderType.Text,
      hidden: isPolicyLikeLayout
    },
    policyIssueDate: {
      name: 'policyIssueDate',
      title: 'Issue Date',
      type: EnhancedTableHeaderType.Date,
      hidden: !isPolicyLikeLayout
    },
    policyEffectiveDate: {
      name: 'policyEffectiveDate',
      title: isPolicyLikeLayout ? 'Effective Date' : 'Policy Effective Date',
      type: EnhancedTableHeaderType.Date
    },
    policyExpiryDate: {
      name: 'policyExpiryDate',
      title: 'Policy Expiry Date',
      type: EnhancedTableHeaderType.Date,
      hidden: isPolicyLikeLayout
    },
    paymentDivisionTotalNumber: {
      name: 'paymentDivisionTotalNumber',
      title: 'Policy Payments #',
      type: EnhancedTableHeaderType.Text,
      hidden: isPolicyLikeLayout
    },
    policyStatus: {
      name: 'policyStatus',
      title: 'Status',
      type: EnhancedTableHeaderType.ColoredText,
      textColorConfig: {
        Bound: MAIN_THEME.color.blue,
        Inforce: MAIN_THEME.color.green,
        Cancelled: MAIN_THEME.color.red,
        'In Progress': MAIN_THEME.color.orange
      }
    },
    createdOn: {
      name: 'createdOn',
      title: 'Created On',
      type: EnhancedTableHeaderType.Date,
      hidden: !isPolicyLikeLayout
    }
  };
};
